const { BUSINESS_MODELS } = require("../../constants");

const getCarteGriseConfig = (journeyType, appConfig, businessModel) => {
  const { configuration } = appConfig;

  const carteGrise =
    businessModel === BUSINESS_MODELS.B2B
      ? configuration.app.solJourney.b2b[journeyType]?.carteGrise
      : configuration.app.solJourney[journeyType]?.carteGrise;

  return carteGrise;
};

module.exports = { getCarteGriseConfig };
